import { ValueObject } from "@singularsystems/neo-core";

export default class DeclineRequestCommand extends ValueObject{
  requestId: number = 0;
}